import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHead, Reveal } from "./Reveal";
import { LocationLinks } from "@/pages/LocationPage";

export const AreaSection = () => (
  <section id="einsatzgebiet" aria-labelledby="area-title" className="bg-paper py-24 text-ink sm:py-32" data-testid="area-section">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <SectionHead id="area-title" tone="light" eyebrow="Einsatzgebiet" title={<>Schifferstadt, Speyer<br />und 25 km Umkreis.</>}
        intro="Von unserem Betrieb in Schifferstadt sind wir schnell in der gesamten Vorderpfalz und auf der badischen Rheinseite – für Termine in 48 Stunden und einen Notdienst innerhalb von 24 Stunden." />
      <Reveal className="mt-10" delay={0.1}><LocationLinks /></Reveal>
      <Link to="/einsatzgebiet" className="btn-dark btn-mega mt-10 w-fit" data-testid="area-section-link">Ganzes Einsatzgebiet ansehen <ArrowRight size={18} className="btn-arrow" /></Link>
    </div>
  </section>
);
